export class NotificationFeedback {
    public NotificationId: string;
    public FeedbackId: number;
    public UserPhone: string;
    public Created: Date;
}
